module.exports = __webpack_public_path__ + "img/play.ee7e6ea4.svg";